import { Pipe, PipeTransform } from '@angular/core';
import { SESSettings } from '@rivethealth/data/email-integration';

@Pipe({ name: 'sesEmail' })
export class SesEmailPipe implements PipeTransform {
  transform(setting: SESSettings) {
    return (
      setting.handle +
      '@' +
      (setting.subdomain ? setting.subdomain + '.' : '') +
      'rivethealth.com'
    );
  }
}
